// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"57846f7a","781":"1f887067","814":"65ecb6a7","981":"d3c19f49"}[chunkId] + ".chunk.css";
};